import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { COUNTRIES_STP, MEX_STATES } from '@app/constants';
import { Developer } from '@app/interfaces';
import { DeveloperService } from '@app/services';

@Component({
  selector: 'mnf-authentication-second-screen',
  templateUrl: './authentication-second-screen.component.html',
  styleUrls: ['./authentication-second-screen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthenticationSecondScreenComponent implements OnInit {

  @Output() form = new EventEmitter();
  @Output() returnStep = new EventEmitter();
  @Input() set user(u: Developer) {
    this.developer = u;
  }

  /** Variable global de developer */
  developer: Developer;

  /** Inicializar formulario */
  secondFormDev: FormGroup;

  /** Valores Si o No */
  defaultOptions = ['Si', 'No'];

  /** Valores de RFC */
  rfcOptions = ['Persona Fisica', 'Persona Moral', 'Otros'];

  /** Variable global email */
  email: string;

  /** Inicializar paises y estados */
  mxStates = MEX_STATES;
  countries = COUNTRIES_STP;

  /** Pasar a paso */
  step = 1;

  /** @Get Forms */
  get forms() {
    return this.secondFormDev.controls;
  }

  constructor(private devServ: DeveloperService) { }

  ngOnInit(): void {
    
    // Asignar email del solicitante
    this.email = this.developer.email;

    /** Validación común en nombres */
    const validatorsInput = [Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(80)])];
    
    /** Iniciar formulario cuando carge el componente */
    this.secondFormDev = new FormGroup({
      company: new FormControl(this.developer?.developer?.company || '', validatorsInput),
      constitutionCountry: new FormControl(this.developer?.developer?.constitutionCountry || '', [Validators.compose([Validators.required])]),
      addressCompany: new FormControl(this.developer?.developer?.addressCompany || '', validatorsInput),
      haveWebSites: new FormControl(this.developer?.developer?.haveWebSites || '', [Validators.compose([Validators.required])]),
      website: new FormControl(this.developer?.developer?.website || ''),
      statusOperateCompany: new FormControl(this.developer?.developer?.statusOperateCompany || '', [Validators.compose([Validators.required])]),
      rfc: new FormControl(this.developer?.developer?.rfc || '', [Validators.compose([Validators.required])]),
      homoclave: new FormControl(this.developer?.developer?.homoclave || '', [Validators.compose([Validators.required])]),
      phone: new FormControl(this.developer.phone || '', [Validators.compose([Validators.required])]),
      foundedMoralPerson: new FormControl(this.developer?.developer.foundedMoralPerson || '', [Validators.compose([Validators.required])])
    })

  }

  /** Función para pasar textos a Capitalize */
  toCapitalize(text: string) {
    var splitStr = text.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1); 
    }
    return splitStr.join(' ');
  }

  /** Actualizar formulario nombre */
  nextStep() {
    const recolectInfo = this.secondFormDev.value;
    this.devServ.updateInfoDevStepOne(recolectInfo, this.email).subscribe(r => {
      this.form.next(r);
    });
  }

  /** Pasar al siguiente paso */
  changeStep(step: number) {
    return this.step = step;
  }

  returnToStep() {
    this.returnStep.next(1);
  }

}
